import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  DialogContent,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import Select, { MenuPlacement } from "react-select";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

const url = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;

export default function OrderAssign(props) {
  const { open, handleClose, selectedUser, SetSelectedUser, handleRoleSubmit } =
    props;
  const [user, setUser] = useState();

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(
        url + `?sort=firstName,asc&size=1000`
      );
      const users = list.data?._embedded?.users.map((data, key) => {
        data.name = data.firstName + " " + data.lastName;
        return data;
      });
      const roleUsers = users.filter(
        (user) =>
          user.roles.includes("ROLE_DESIGNER") ||
          user.roles.includes("ROLE_DESGNSTHEAD")
      );
      setUser(
        roleUsers.map((item) => ({
          value: item.userName,
          label: `${item.firstName} ${item.lastName}`,
        }))
      );
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleUserChange = (value) => {
    if (!value) return;
    SetSelectedUser(value);
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
        <AppBar position="static" color="secondary">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              Order Assign to Designer
            </Typography>
            <IconButton onClick={handleClose} color="inherit">
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
          <Box sx={{ mb: 2 }}>
            <Select
              name="assignDesigner"
              value={selectedUser}
              //onChange={handleUserChange}
              options={user}
              styles={customStyles()}
            />
          </Box>
          <Button
            type="button"
            variant="contained"
            color="secondary"
            size="large"
            // onClick={handleRoleSubmit}
          >
            Submit
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
